/* eslint-disable react-hooks/exhaustive-deps */

import {
    makeStyles,
    Theme,
    createStyles,
    Grid,
    Typography,
    Button,
    MenuItem,
    Select,
    TextField,
} from "@material-ui/core";
import { Error } from "@material-ui/icons";
import React from "react";
import { useTranslation } from "react-i18next";
import {
    addressDefaultValue,
    HotelInputDefaultValue,
} from "../../../utils/defaultNullValues";
import { HotelService } from "./services/hotelService";
import { StandardTextField } from "../components/StandardTextField";
import { useHistory } from "react-router-dom";
import { IHotel } from "../../../utils/HotelInterface";
import { Rating, Stack } from "@mui/material";
import { useParams } from "react-router";
import { serverConfig } from "../../../utils/config";
import { PreviewPhotos } from "./components/PreviewPhotos/PreviewPhotos";
import { UploadPhotos } from "../../Properties/components/UploadPhotos";
import { DescriptionRichText } from "../../components/DescriptionRichText";
import { IAddress } from "../../../utils/AnnounceInterfaces";
import { CountryService } from "../Countries/services/EquipmentCountry";
import { colors } from "../../../styles/defaultColors";
import {
    getErrorLabel,
    PromotionErrorMessage,
} from "../../../utils/UserInterfaces";
import { SelectEndornmentNation } from "../../components/Register/TextFieldNation";
import { CountryPhoneList } from "../../../utils/CountryList";
import { IPays, IVille } from "../../../utils/DiversInterfaces";

const styles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            width: "100%",
            textAlign: "center",
            [theme.breakpoints.down("sm")]: {
                minHeight: 1200,
            },
            [theme.breakpoints.up("lg")]: {
                minHeight: 800,
            },
        },

        inpuText: {
            marginBottom: theme.spacing(5),
        },
        uploadFile: {
            width: "100%",
            background: "antiquewhite",
            padding: "14px",
            minHeight: "6em",
            marginBottom: "16px",
            fontFamily: "Josefin Sans",
            textTransform: "inherit",
            fontSize: 18,
            borderRadius: 8,
        },
        changeImage: {
            fontFamily: "Josefin Sans",
            textTransform: "inherit",
            fontSize: 14,
        },

        propertiesHeader: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
        },
        propertiesTitle: {
            fontSize: 22,
            fontFamily: "Josefin Sans",
            color: "#890608",
            marginTop: 40,
            marginBottom: 60,
        },
        propertiesStepper: {
            width: "40%",
            marginBottom: 70,

            [theme.breakpoints.down("sm")]: {
                width: "70%",
            },
        },
        propertiesCheck: {},
        propertiesCheckbox: {
            [theme.breakpoints.down("sm")]: {
                margin: "0 auto",
            },
        },
        checkboxLabel: {
            "&:not(:last-child)": {
                marginBottom: 20,
            },
            "& span": {
                fontFamily: "Josefin Sans",
                color: "#5F5F5F",
            },
        },
        checkboxLegend: {
            textAlign: "left",
            fontSize: 18,
            fontFamily: "Josefin Sans",
            color: "#000000",
            marginBottom: 30,
        },
        checkboxGroup: {},
        propertiesBtn: {
            display: "flex",
            justifyContent: "space-between",
            marginTop: 120,
            [theme.breakpoints.down("sm")]: {
                margin: "0 auto",
            },
        },
        Button: {
            fontFamily: "Josefin Sans",
            color: "#890608",
            textTransform: "capitalize",
        },
        ButtonPrevious: {
            textTransform: "capitalize",
            color: "#000000",
        },
        inputLabel: {
            fontSize: 14,
            fontFamily: "Josefin Sans",
            color: "#000000",
        },
        containerLabel: {
            textAlign: "left",
        },
        announcePriceContainer: {
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
        },
        announcePriceItem: {
            flex: 0.47,
        },
        "@global": {
            ".MuiOutlinedInput-input": {
                padding: "9px 14px",
            },
        },
        formContainer: {
            margin: "0 auto",
        },
        gridContainer: {},

        avatar: {
            display: "flex",
            width: 100,
            height: 100,
            border: "1px solid",
            borderRadius: "50%",
            alignItems: "center",
            justifyContent: "center",
            backgroundSize: "cover",
        },
        button: {
            background: "#890608",
            borderRadius: 100,
            textTransform: "none",
            fontSize: 14,
            marginBottom: theme.spacing(2),
            marginTop: theme.spacing(2),
            textAlign: "center",
            fontFamily: "Josefin Sans",
            color: "#ffffff",
            padding: "8px 14px",
            "&:hover": {
                background: "#B5551B",
            },
        },
        imgUpload: {
            display: "flex",
            width: 220,
            height: 160,
            border: "1px solid",
            alignItems: "center",
            justifyContent: "center",
            backgroundSize: "cover",
        },
        avatarProfil: {
            display: "flex",
            flexDirection: "column",
            marginTop: 15,
            marginBottom: 10,
        },
        isPreviewing: {
            color: "white",
            borderRadius: "50%",
            background: "#EA7606",
        },
        isNotPreviewing: {
            color: "#000000",
            borderRadius: "inherit",
            background: "inherit",
        },
        span: {
            display: "flex",
            justifyContent: "center",
            marginTop: 9,
            fontFamily: "Josefin Sans",
            fontSize: 14,
        },
        spanProfil: {
            fontFamily: "Josefin Sans",
            fontSize: 14,
            marginBottom: 20,
        },
        icon: {
            position: "relative",
            top: -4,
        },
        errors: {
            color: colors.danger,
            background: colors.backgroundDanger,
            width: "100%",
            textAlign: "center",
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            borderRadius: 5,
            "& p": {
                padding: 10,
            },
        },
        textField: {
            "&::placeholder": {
                color: "#000",
            },
            marginTop: 15,
            marginBottom: 15,
        },
        input: {
            "&::placeholder": {
                textOverflow: "ellipsis !important",
                color: "#000000",
                opacity: 10,
            },
        },
        updateButton: {
            borderRadius: 100,
            textTransform: "none",
            fontSize: 14,
            marginBottom: theme.spacing(2),
            marginTop: theme.spacing(2),
            textAlign: "center",
            fontFamily: "Josefin Sans",
            background: "#AAAAAA",
            color: "#ffffff",
            padding: "8px 14px",
            "&:hover": {
                background: "#B5551B",
            },
        },
        inputAvatar: {
            display: "none",
        },
        cover: {
            fontSize: 18,
            fontWeight: "normal",
            textAlign: "left",
            marginBottom: 33,
        },
        img: {
            maxWidth: 250,
            maxHeight: 150,
        },
        star: {
            marginTop: 10,
        },
    })
);
const countryService = new CountryService();
const hotelService = new HotelService();
const Env = serverConfig;
export const HotelEdit = () => {
    const classes = styles();
    // const theme = useTheme();
    const [hotelInput, setHotel] = React.useState<IHotel>(
        HotelInputDefaultValue
    );
    const [note, setNote] = React.useState<number | null>(0);
    const { t } = useTranslation();
    const [previewPhotos, setPreviewPhotos] = React.useState<any>([]);
    const [newPhotos, setNewPhotos] = React.useState<any>([]);
    const [isUpdating, setIsUpdating] = React.useState(false);
    const [address, setAddress] = React.useState<any>({addressDefaultValue});
    const [paysList, setPaysList] = React.useState<any[]>();
    const [errorMessages, setErrorMessages] = React.useState<string>("");
    const [logourgent, setLogoPaysurgent] = React.useState<string>("");
    const [paysgerant, setPayGerant] = React.useState<string>("");
    const [logourgentProp, setLogoPaysurgentProp] = React.useState<string>("");
    const [paysProp, setPayProp] = React.useState<string>("");
    const [codephoneurgentProp, setCodePhoneurgentProp] =
        React.useState<string>("");
    const [codephoneurgent, setCodePhoneurgent] = React.useState<string>("");
    const [phoneGerant, setPhoneGerant] = React.useState<string>("");
    const [tabPays, setTabPays] = React.useState<IVille[]>([]);
    const [filteredCities, setFilteredCities] = React.useState<IVille[]>([]);
    let errors: string[] = [];
    const { i18n } = useTranslation();

    const getLocalizedName = (entity: IPays | IVille) => {
        return i18n.language === 'fr' ? entity.nomFR : entity.nomEN;
    };
    // const [photoURL, setPhotoURL] = React.useState<string>("");
    const handleOnChangeNationUrgent = (val: any) => {
        setCodePhoneurgent(val.dial_code);
        setPayGerant(val.name);
        setLogoPaysurgent(val.code);
    };
    const handleOnChangeNationUrgentProp = (val: any) => {
        setCodePhoneurgentProp(val.dial_code);
        setPayProp(val.name);
        setLogoPaysurgentProp(val.code);
    };
    const handleOnChangeSelect = (key: string, v: string) => {
        // console.log("key", key, "value", v);
        setHotel({ ...hotelInput, [key]: v });
    };

    const params: { id: string } = useParams();

    const triggerUpdatingForm = () => {
        setIsUpdating(!isUpdating);
    };
    React.useEffect(() => {
        setHotel({
            ...hotelInput,
            phoneUrgent: hotelInput.numberPhoneUrgent,
            codephoneurgent: codephoneurgent,
            paysgerant: paysgerant,
        });
    }, [
        hotelInput.numberPhoneUrgent,
        hotelInput.paysgerant,
        hotelInput.codephoneurgent,
    ]);
    React.useEffect(() => {
        setHotel({
            ...hotelInput,
            phoneUrgentProp: hotelInput.phone,
            codephoneurgentProp: codephoneurgentProp,
            paysProp: paysProp,
        });
    }, [hotelInput.phone, hotelInput.paysProp, hotelInput.phoneUrgentProp]);
    
    React.useEffect(() => {
        if (address.country?._id) {
            const selectedCountry = paysList?.find(p => p._id === address.country?._id);
            setTabPays(selectedCountry?.villes || []);
            //console.log('Derived cities:', selectedCountry?.villes);
        }
    }, [address.country, paysList]);

    const onChangeAddress = (event: any): void => {
        setAddress({ ...address, [event.target.name]: event.target.value });
    };
    React.useEffect(() => {
        hotelService
            .getAllHotel()
            .then((response) => {})
            .catch((error) => {
                //console.log("admin equipment error", error);
            });
        if (params.id) {
            hotelService
                .getHotelById(params.id)
                .then((response) => {
                    if (response.success) {
                        setCodePhoneurgentProp(
                            response.data.hotel.codephoneurgentProp
                        );
                        setCodePhoneurgent(response.data.hotel.codephoneurgent);
                        setPayProp(response.data.hotel.paysProp);
                        setPayGerant(response.data.hotel.paysgerant);
                        setHotel(response.data.hotel);
                        setNote(response.data.hotel.stars);
                        setAddress(response.data.hotel.address);
                        setPhoneGerant(response.data.hotel.phoneUrgent);
                        setPreviewPhotos(
                            response.data.hotel.photos.map((photo: any) => {
                                if (photo.filename) {
                                    return {
                                        id: photo._id,
                                        url: `${Env.ApiRoot}/images/hotels/${photo.filename}`,
                                        filename: photo.filename,
                                    };
                                }
                                return {
                                    id: photo._id,
                                    url: "",
                                };
                            })
                        );
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }, [params.id]);
    
    React.useEffect(() => {
        countryService.getAllCountries()
        .then(response => {
        if (response.success) {
            setPaysList(response.data);
            //console.log('Fetched countries with embedded cities:', response.data);
        }
        });
    }, []);

    const invalidCity: IVille = {
            _id: '', // Default empty ID
            count: '0', // Placeholder count
            name: 'Invalid City', // Default name
            nomFR: 'Ville invalide', // Optional
            nomEN: 'Invalid City', // Optional
            quartiers: [], // Optional
        };
    
        const invalidCountry: IPays = {
            _id: '', // Default or placeholder ID
            name: 'Invalid Country', // Placeholder name
            nomFR: 'Pays invalide', // Placeholder French name
            nomEN: 'Invalid Country', // Placeholder English name
            status: false, // Default status
            currencyCode: '', // Placeholder currency code
            villes: [], // Empty array for cities
            // Optional fields can be left undefined or filled with placeholders if necessary
            photo: undefined,
            countryId: undefined,
            registeredTaxName: undefined,
            taxReference: undefined,
            businessType: undefined,
            postalAdress: undefined,
            officeNumbers: undefined,
            phoneCode: undefined
        };
    

       const onChangePropertyPaysHandler = (event: React.ChangeEvent<{ value: unknown }>): void => {
            const selectedCountryName = event.target.value as string;
        
            const selectedCountry = paysList?.find(
                (country: IPays) =>
                    (i18n.language === "fr" ? country.nomFR : country.nomEN) === selectedCountryName
            );
        
            if (selectedCountry) {
                setAddress((prevAddress: IAddress) => ({
                    ...prevAddress,
                    country: selectedCountry,
                    city: invalidCity, // Clear city when country changes
                }));
        
                setFilteredCities(selectedCountry.villes || []);
            } else {
                setAddress((prevAddress: IAddress) => ({
                    ...prevAddress,
                    country: invalidCountry,
                    city: invalidCity,
                }));
        
                setFilteredCities([]);
            }
        };

        // Update the city change handler
            const onChangePropertyVilleHandler = (event: React.ChangeEvent<{ value: unknown }>) => {
                const selectedCityName = event.target.value as string;
            
                const selectedCity = filteredCities.find(
                    (city: IVille) =>
                        (i18n.language === "fr" ? city.nomFR : city.nomEN) === selectedCityName
                );
            
                setAddress((prevAddress: IAddress) => ({
                    ...prevAddress,
                    city: selectedCity || invalidCity, // Clear city if not found
                }));
            };

    React.useEffect(() => {
        setHotel({
            ...hotelInput,
            address,
        });
    }, [address]);
    const history = useHistory();
    const onChangeStar = (
        event: React.SyntheticEvent<Element, Event>,
        newValue: number | null
    ) => {
        let hotelStars = newValue === null ? 0 : newValue;
        setNote(hotelStars);
        setHotel({ ...hotelInput, stars: hotelStars });
    };
    const handleChange = (n: string, v: string) => {
        setHotel({ ...hotelInput, [n]: v });
    };

    const onChangePhoto = (photos: any) => {
        setNewPhotos(photos);
        setHotel({
            ...hotelInput,
            photos: [...hotelInput.photos, newPhotos],
        });
    };

    let tab: any = [];
    hotelInput.photos.forEach((pho: any) => {
        if (pho.filename !== undefined) {
            tab.push(pho);
        }
    });

    const isFromValidate = (values: IAddress): boolean => {
        if (values.quartier === "") {
            if (!errors.includes("EMPTY PROMOTION TITLE"))
                errors = [...errors, "EMPTY PROMOTION TITLE"];
        }
        return !Boolean(errors.length);
    };

    const showErrorsMessages = () => {
        let allErrorMessages = "";
        errors.forEach((error) => {
            if (error === "EMPTY PROMOTION TITLE") {
                allErrorMessages +=
                    "," + getErrorLabel(PromotionErrorMessage.EmptyQuartie);
            }
        });
        setErrorMessages(
            allErrorMessages.substring(1, allErrorMessages.length)
        );
    };

    const handleSubmit = (e: any) => {
        e.preventDefault();
        if (isFromValidate(address)) {
            hotelService
                .saveHotel({
                    ...hotelInput,
                    // admin: user._id,

                    photos: tab,
                })
                .then((response) => {
                    if (response.success) {
                        if (newPhotos.length) {
                            newPhotos.forEach((photo: any, index: number) => {
                                let formD = new FormData();
                                formD.append(`photos`, photo.file);
                                if (hotelInput._id !== undefined) {
                                    hotelService
                                        .savePropertyPhotosById(
                                            hotelInput._id,
                                            formD
                                        )
                                        .then((response) => {})
                                        .catch((error) => {
                                            console.log(error);
                                        });
                                }
                            });
                        }
                        setErrorMessages("");
                        errors = [];
                        setTimeout(() => {
                            history.push("/hotel");
                        }, 1000);
                    }
                    // setIsUpdating(false);
                })
                .catch((error) => {
                    console.log(error);
                });
        } else {
            showErrorsMessages();
            return false;
        }
    };
    const onDeletePhoto = (
        idProperty: string,
        idPhoto: string,
        photoName?: string
    ) => {
        if (photoName) {
            hotelService
                .deletePropertyPhotoByName(idProperty, photoName)
                .then((response) => {
                    if (response.success) {
                        refreshPhotos();
                    }
                });
        } else if (idPhoto) {
            hotelService
                .deletePropertyPhotoById(idProperty, idPhoto)
                .then((response) => {
                    if (response.success) {
                        refreshPhotos();
                    }
                });
        }
    };
    const refreshPhotos = () => {
        hotelService
            .refreshPropertyPhotos(hotelInput._id || "")
            .then((response) => {
                if (response.success) {
                    setPreviewPhotos(
                        response.photos.map((photo: any) => {
                            if (photo.filename) {
                                return {
                                    id: photo._id,
                                    url: `${Env.ApiRoot}/images/hotels/${photo.filename}`,
                                    filename: photo.filename,
                                };
                            }
                            return {
                                id: photo._id,
                                url: "",
                            };
                        })
                    );

                    setHotel({
                        ...hotelInput,
                        photos: response.photos,
                    });
                }
            })
            .catch((error) => {
                console.log("errr", error);
            });
    };
    const cancelUpdatingForm = () => {};
    React.useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        })
    }, [])
    
    return (
        <div className={classes.container}>
            <Grid container direction="column" style={{ margin: "0 auto" }}>
                <Grid item className={classes.propertiesHeader}>
                    <Typography
                        variant="h5"
                        gutterBottom
                        className={classes.propertiesTitle}
                    >
                        {t("label.modifier-un-hotel")}
                    </Typography>
                </Grid>
                <Grid
                    item
                    container
                    justifyContent="space-between"
                    direction="row"
                    spacing={5}
                    className={classes.gridContainer}
                >
                    <Grid item lg={5} md={12} sm={12}>
                        {!previewPhotos.length && (
                            <h3>{t("propriete.labels.aucunePhoto")}</h3>
                        )}
                        {previewPhotos.length && (
                            <PreviewPhotos
                                photos={previewPhotos}
                                isUpdating={true}
                                idProperty={hotelInput._id || ""}
                                onDeletePhoto={onDeletePhoto}
                            />
                        )}
                        <UploadPhotos
                            handleChangePhotos={onChangePhoto}
                            isUpdating={false}
                            selectedPhotos={newPhotos}
                        />
                    </Grid>
                    <Grid
                        item
                        lg={7}
                        md={12}
                        sm={12}
                        className={classes.propertiesCheck}
                    >
                        <div className={classes.propertiesCheckbox}>
                            <Grid container style={{ textAlign: "left" }}>
                                <StandardTextField
                                    id="hotelCompany"
                                    label={`${t(
                                        "hotel.label.nomEtablissement"
                                    )} :`}
                                    name="companyName"
                                    value={hotelInput.companyName}
                                    handleChange={(e) =>
                                        handleChange(
                                            e.target.name,
                                            e.target.value
                                        )
                                    }
                                />

                                <Grid item lg={12} sm={12} xs={12}>
                                    <label htmlFor="propertyCountry">
                                        {t("propriete.labels.pays")} *:
                                    </label>
                                </Grid>
                                <Grid item lg={12} sm={12} xs={12}>
                                    <Select
                                        id="propertyCountry"
                                        name="country"
                                        fullWidth
                                        value={i18n.language === "fr" ? address.country?.nomFR || "" : address.country?.nomEN || ""}
                                        onChange={onChangePropertyPaysHandler}
                                        inputProps={{
                                            readOnly: !isUpdating,
                                        }}
                                    >
                                            {paysList && paysList.map((country: IPays) => (
                                            <MenuItem value={i18n.language === "fr" ? country.nomFR : country.nomEN} key={country._id}>
                                                {i18n.language === "fr" ? country.nomFR : country.nomEN}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Grid>
                                <div
                                    style={{
                                        padding: "6",
                                        marginBottom: "50px",
                                    }}
                                ></div>
                                <Grid
                                    item
                                    lg={12}
                                    sm={12}
                                    xs={12}
                                    style={{ marginBottom: "60" }}
                                >
                                    <label htmlFor="propertyCity">
                                        {t("propriete.labels.nomDeLaVille")} *:
                                    </label>
                                </Grid>
                                <Grid
                                    item
                                    lg={12}
                                    sm={12}
                                    xs={12}
                                    style={{ marginTop: "100" }}
                                >
                                    <Select
                                        id="propertyCity"
                                        name="city"
                                        fullWidth
                                        value={i18n.language === "fr" ? address.city?.nomFR || "" : address.city?.nomEN || ""}
                                        onChange={onChangePropertyVilleHandler}
                                        inputProps={{
                                            readOnly: !isUpdating,
                                        }}
                                    >
                                        {filteredCities.map((city: IVille) => (
                                            <MenuItem value={i18n.language === "fr" ? city.nomFR : city.nomEN} key={city._id}>
                                                {i18n.language === "fr" ? city.nomFR : city.nomEN}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </Grid>
                                <div
                                    style={{
                                        padding: "6",
                                        marginBottom: "50px",
                                    }}
                                ></div>
                                <StandardTextField
                                    id="hotelTel"
                                    label={`${t(
                                        "propriete.labels.quartier"
                                    )} *:`}
                                    name="quartier"
                                    value={address.quartier}
                                    handleChange={onChangeAddress}
                                />
                                <StandardTextField
                                    id="hotelTel"
                                    label={`${t(
                                        "propriete.labels.nomDeRue"
                                    )} :`}
                                    name="street"
                                    value={address.street}
                                    handleChange={onChangeAddress}
                                />
                                <StandardTextField
                                    id="hotelTel"
                                    label={`${t(
                                        "propriete.labels.etatOuProvince"
                                    )} :`}
                                    name="state"
                                    value={address.state}
                                    handleChange={onChangeAddress}
                                />
                                <StandardTextField
                                    id="hotelTel"
                                    label={`${t(
                                        "propriete.labels.lieu-dit"
                                    )} :`}
                                    name="lieu_dit"
                                    value={address.lieu_dit}
                                    handleChange={onChangeAddress}
                                />
                                <StandardTextField
                                    id="hotelTel"
                                    label={`${t(
                                        "propriete.labels.codePostal"
                                    )} :`}
                                    name="zipcode"
                                    value={address.zipcode}
                                    handleChange={onChangeAddress}
                                />
                                <StandardTextField
                                    id="hotelCompany"
                                    label={`${t(
                                        "hotel.label.nomProprietaire"
                                    )} :`}
                                    name="proprietaire"
                                    value={hotelInput.proprietaire}
                                    handleChange={(e) =>
                                        handleChange(
                                            e.target.name,
                                            e.target.value
                                        )
                                    }
                                />
                                <Grid item lg={4} md={4} sm={4} xs={4}>
                                    <SelectEndornmentNation
                                        id="country"
                                        name="paysProp"
                                        values={CountryPhoneList}
                                        IconElement={
                                            logourgentProp ? (
                                                <img
                                                    style={{ width: 32 }}
                                                    src={`${logourgentProp}`}
                                                    alt={"Flag"}
                                                />
                                            ) : (
                                                ""
                                            )
                                        }
                                        selectedValue={paysProp}
                                        handleOnChange={handleOnChangeSelect}
                                        handleOnChangeNation={
                                            handleOnChangeNationUrgentProp
                                        }
                                    />
                                </Grid>
                                <Grid item lg={8} md={8} sm={8} xs={8}>
                                    <Stack
                                        direction="row"
                                        alignItems="center"
                                        display="flex"
                                    >
                                        <TextField
                                            autoFocus
                                            margin="dense"
                                            id="phoneUrgent"
                                            name="phone"
                                            variant="outlined"
                                            onChange={(e) =>
                                                handleChange(
                                                    e.target.name,
                                                    e.target.value
                                                )
                                            }
                                            value={hotelInput.phone}
                                            type="text"
                                            classes={{
                                                root: classes.textField,
                                            }}
                                            fullWidth
                                            label="contact propriétaire"
                                            InputProps={{
                                                startAdornment: (
                                                    <div
                                                        style={{
                                                            marginRight: 10,
                                                        }}
                                                    >
                                                        {codephoneurgentProp}
                                                    </div>
                                                ),
                                                classes: {
                                                    input: classes["input"],
                                                },
                                            }}
                                        />
                                    </Stack>
                                </Grid>
                                <StandardTextField
                                    id="hotelCompany"
                                    label={`${t("hotel.label.nomGerant")} :`}
                                    name="gerant"
                                    value={hotelInput.gerant}
                                    handleChange={(e) =>
                                        handleChange(
                                            e.target.name,
                                            e.target.value
                                        )
                                    }
                                />
                                <Grid item lg={4} md={4} sm={4} xs={4}>
                                    <SelectEndornmentNation
                                        id="country"
                                        name="paysgerant"
                                        values={CountryPhoneList}
                                        IconElement={
                                            logourgent ? (
                                                <img
                                                    style={{ width: 32 }}
                                                    src={`${logourgent}`}
                                                    alt={"Flag"}
                                                />
                                            ) : (
                                                ""
                                            )
                                        }
                                        selectedValue={paysgerant}
                                        handleOnChange={handleOnChangeSelect}
                                        handleOnChangeNation={
                                            handleOnChangeNationUrgent
                                        }
                                    />
                                </Grid>
                                <Grid item lg={8} md={8} sm={8} xs={8}>
                                    <Stack
                                        direction="row"
                                        alignItems="center"
                                        display="flex"
                                    >
                                        <TextField
                                            autoFocus
                                            margin="dense"
                                            id="phoneUrgent"
                                            name="phoneUrgent"
                                            variant="outlined"
                                            onChange={(e) =>
                                                handleChange(
                                                    e.target.name,
                                                    e.target.value
                                                )
                                            }
                                            value={phoneGerant}
                                            type="text"
                                            classes={{
                                                root: classes.textField,
                                            }}
                                            fullWidth
                                            label="contact gérant"
                                            InputProps={{
                                                startAdornment: (
                                                    <div
                                                        style={{
                                                            marginRight: 10,
                                                        }}
                                                    >
                                                        {codephoneurgent}
                                                    </div>
                                                ),
                                                classes: {
                                                    input: classes["input"],
                                                },
                                            }}
                                        />
                                    </Stack>
                                </Grid>
                                <StandardTextField
                                    id="hotelCompany"
                                    label={`${t(
                                        "hotel.label.nombreChambres"
                                    )} :*`}
                                    name="rooms"
                                    value={hotelInput.rooms}
                                    handleChange={(e) =>
                                        handleChange(
                                            e.target.name,
                                            e.target.value
                                        )
                                    }
                                />

                                <Typography component="legend">
                                    {t("hotel.label.nbrStar")} :
                                </Typography>
                                <Rating
                                    name="simple-controlled"
                                    value={note}
                                    onChange={onChangeStar}
                                />
                                <DescriptionRichText
                                    handleChange={(e: any) =>
                                        handleChange(
                                            e.target.name,
                                            e.target.value
                                        )
                                    }
                                    isCanceled={!isUpdating}
                                    description={hotelInput.description}
                                />
                            </Grid>
                            {errorMessages && (
                                <Grid item xs={12} md={12} lg={12}>
                                    <div className={classes.errors}>
                                        <Typography>
                                            <Error />
                                            <br />
                                            <span>{errorMessages}</span>
                                        </Typography>
                                    </div>
                                </Grid>
                            )}
                        </div>
                        <div className={classes.propertiesBtn}>
                            <Button
                                className={classes.updateButton}
                                onClick={
                                    isUpdating
                                        ? cancelUpdatingForm
                                        : triggerUpdatingForm
                                }
                            >
                                {isUpdating
                                    ? `${t(
                                          "propriete.labels.annuler-la-modification"
                                      )}`
                                    : `${t("propriete.labels.modifier")}`}
                            </Button>

                            {isUpdating && (
                                <Button
                                    size="small"
                                    type="submit"
                                    onClick={handleSubmit}
                                    className={classes.button}
                                >
                                    {t("propriete.buttonSave")}
                                </Button>
                            )}
                        </div>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
};
